import { PostMessageKeys } from "constants/constants";

export const postMessage = (data: any) => {
  window.parent.postMessage(data, { targetOrigin: "*" });
};

export const handleMessage = <T>(
  event: MessageEvent<T>,
  callback: (event: MessageEvent<T>) => void,
  options?: { origins?: string[] }
) => {
  const {
    origins = [
      "http://localhost:3000",
      "https://route-planner-377013.web.app",
      "https://route-planner-377013.firebaseapp.com/",
    ],
  } = options ?? {};

  if (origins.includes("*")) {
    callback(event);
    return;
  }

  if (origins.includes(event.origin)) {
    callback(event);
  }
};

export const postSaveEmail = (email: string) => {
  postMessage({
    email,
    method: "post",
    key: PostMessageKeys.RouteBuilder.Email,
  });
};

export const postGetEmail = () => {
  postMessage({ key: PostMessageKeys.RouteBuilder.Email, method: "get" });
};

export const postDeleteEmail = () => {
  postMessage({ key: PostMessageKeys.RouteBuilder.Email, method: "delete" });
};

export const postMessageToIframe = (data: object) => {
  const iframe = document.querySelector("iframe");
  iframe?.contentWindow?.postMessage(data, { targetOrigin: "*" });
};

export const setCloseButtonState = (state: "visible" | "hidden") => {
  if (state === "hidden") {
    postMessage({ key: PostMessageKeys.RouteBuilder.ScrollToTop });
  }

  postMessage({
    state,
    key: PostMessageKeys.RouteBuilder.CloseButtonVisibility,
  });
};
